import { useTranslation } from 'react-i18next';
import MonitoringPanel from '../components/MonitoringPanel';

/**
 * Die Serverübersicht als eigene Seite.
 *
 * Denselben Inhalt gibt es als Reiter im Dashboard — hier steht er unter einer
 * eigenen Adresse, weil man ihn oft direkt ansteuert und nicht erst über eine
 * andere Seite. Eine Kopie ist es nicht: beide zeigen dieselbe Komponente.
 */
export default function MonitoringPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-slate-800">{t('nav.monitoring')}</h1>
        <p className="mt-0.5 text-xs text-slate-500">
          Last, Speicher und Platte aller Server. „Meldet sich" heißt: es treffen
          Messwerte ein — nicht, was in der Serverliste steht.
        </p>
      </div>
      <MonitoringPanel />
    </div>
  );
}
